import { createContext } from 'react';

import { DEFAULT_CONFIG } from '../constants';
import { useContextFallback } from '../hooks';
import { AppConfig } from '../models';

const AppConfigContext = createContext<AppConfig | undefined>(undefined);
AppConfigContext.displayName = 'AppConfigContext';

type AppConfigProviderProps = { config: AppConfig };

export const AppConfigProvider: React.FC<AppConfigProviderProps> = ({
  config,
  children,
}) => (
  <AppConfigContext.Provider value={{ ...DEFAULT_CONFIG, ...config }}>
    {children}
  </AppConfigContext.Provider>
);

export const useAppConfig = () => useContextFallback(AppConfigContext);
